import React from "react";
import Banner from "../components/Banner";
import Footer from "../components/Footer";
import Main from "../components/Main";

function Home() {
    return (
        <React.Fragment>
            <Banner />
            <Main />
            <Footer />
        </React.Fragment>
    )
}

export default Home